<template>
  <div>
    <div style="margin-bottom: 20px;" v-if="data.type == 'kochirma'">
      <PechatLogo :stat="true" />
      <div style="text-align: center; margin-top: 10px;">
        <label
          ><b
            >Tibbiy muassasadagi bemorning tibbiy bayonnomasidan ko‘chirma №
            {{ selectShablonJson.value22 }}</b
          ></label
        >
      </div>
    </div>
    <div v-else-if="data.type == 'epikriz'">
      <div style="text-align: center; margin-top: 10px;">
        <label
          ><b> {{ selectShablonJson.value23 }} Chiqaruv epikrizi.</b></label
        >
      </div>
    </div>
    <div
      class="display-flex"
      style="justify-content: space-between; border-bottom: 1px solid #000; margin-bottom: 10px;"
    >
      <div>
        <label
          ><b>Bemor: {{ data.bemor.fullname }}</b></label
        >
        <br />
        <label
          ><b
            >Tug'ilgan sanasi: {{ data.bemor.birthday | dateFormat }}</b
          ></label
        ><br />
        <label
          ><b>Manzili:</b>
          {{ data.bemor.region ? data.bemor.region.name : "" }}
          {{ data.bemor.district ? data.bemor.district.name : "" }}
          {{ data.bemor.addres }}</label
        ><br />
        <label
          ><b>Tel raqami: {{ data.bemor.phone }}</b></label
        >
      </div>
      <div>
        <label
          ><b>Shifoxonaga yotqizilgan kun:</b
          >{{ selectShablonJson.value1 }}</label
        ><br />
        <label
          ><b>Shifoxonadan chiqarilgan kun:</b
          >{{ selectShablonJson.value2 }}</label
        ><br />
        <label><b>Bo'lim:</b>{{ selectShablonJson.value21 }}</label>
      </div>
    </div>
    <label><b>Dastlabki tashxis:</b></label> <br />
    <label><b>Asosiy:</b> {{ selectShablonJson.value3 }}</label> <br />
    <label><b>Hamroh:</b> {{ selectShablonJson.value4 }}</label> <br />
    <label><b>Asorati:</b> {{ selectShablonJson.value5 }}</label> <br />
    <label><b>Yakuniy tashxis:</b></label> <br />
    <label><b>Asosiy:</b> {{ selectShablonJson.value6 }}</label> <br />
    <label><b>Xamroh:</b> {{ selectShablonJson.value7 }}</label
    ><br />
    <label><b>Asorati:</b> {{ selectShablonJson.value8 }}</label
    ><br />
    <label class="multiline-text"
      ><b>Kelgandagi shikoyatlari: </b>{{ selectShablonJson.value9 }}</label
    >
    <br />
    <label class="multiline-text"
      ><b>Anamnezidan:</b> {{ selectShablonJson.value10 }}</label
    ><br />
    <label class="multiline-text"
      ><b>Obyektiv:</b> {{ selectShablonJson.value11 }}</label
    ><br />
    <div v-for="(item, index) in selectShablonJson.value12" :key="index">
      <label
        ><b>{{ item.name }}</b></label
      >
      <br />
      <label>{{ item.value }}</label>
    </div>
    <label>{{ selectShablonJson.value13 }}</label
    ><br />
    <label class="multiline-text"
      ><b>Ambulator nazorat:</b> {{ selectShablonJson.value14 }}</label
    ><br />
    <label class="multiline-text"
      ><b>Tavsiyalar:</b> {{ selectShablonJson.value15 }}</label
    ><br />
    <label class="multiline-text"
      ><b>Tabletkalar:</b> {{ selectShablonJson.value16 }}</label
    ><br />
    <br />
    <label><b>Davolovchi shifokor:</b> {{ selectShablonJson.value17 }}</label
    ><br />
    <label><b>Bo'lim boshlig'i:</b> {{ selectShablonJson.value19 }}</label
    ><br />
    <label
      ><b>Davolash ishlari bo'yicha derektor movini:</b>
      {{ selectShablonJson.value18 }}</label
    >
  </div>
</template>

<script>
import moment from "moment";
import PechatLogo from "../PechatLogo.vue";
export default {
  components: { PechatLogo },
  data() {
    return {
      selectShablonJson: {},
      data: {}
    };
  },
  filters: {
    dateFormat: function(date) {
      if (date) {
        return moment.unix(date).format("DD.MM.YYYY");
      } else {
        return "";
      }
    }
  },
  created: function() {
    this.data = JSON.parse(localStorage.getItem("kas_tar_koch"));
    this.selectShablonJson = JSON.parse(this.data.value.toString());
  },
  mounted() {
    localStorage.removeItem("kas_tar_koch");
    window.print();
    setTimeout(() => {
      //   this.$router.push({ path: "/user" });
      window.close();
    }, 3000);
  }
};
</script>

<style lang="scss">
.multiline-text {
  white-space: pre-line;
}
label {
  font-family: "Times New Roman", Times, serif;
  // margin-top: 5px;
  font-size: 14pt;
  line-height: 14pt;
  // font-size: 13pt;
  font-weight: 500;
  margin-right: 5px;
}
.display-flex {
  display: flex;
}
</style>
